import React, { useState } from 'react';
import logo_white from '../assets/images/logo/chronos_HVIT_logo_CMYK.svg';
import TextInputClearable from '../components/widget/TextInputClearable';

function Login({ login }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    login(username, password);
  };

  const handleUsernameChange = (e) => {
    setUsername(e.target.value)
  }

  const handlePasswordChange = (e) => {
    setPassword(e.target.value)
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSubmit(e);
    }
  };

  return (
    <main className="dark-centered-background height-100" style={{position: "relative"}}>
        <img id="startpage-chronos-logo" src={logo_white} alt="White chronos-logo" />
        <form className="configure-container" onKeyDown={handleKeyDown}>
            <div className='flex-column' style={{gap: "32px"}}>
                <div className="centered-horizontal" style={{gap: "8px"}}>
                        <h1 className="light no-margin">Login</h1>
                </div>

                <div className='flex-column' style={{gap: "12px"}}>
                <TextInputClearable id="username" placeholder="Username.." onChange={handleUsernameChange}/>
                <TextInputClearable id="password" placeholder="Password.." type='password' onChange={handlePasswordChange}/>
                </div>
                
                <div role="button" type="submit" className="standard-button" onClick={handleSubmit}>
                    <span className="font-large light homepage-button-txt" >Login</span>
                </div>
            </div>
        </form>
    </main>
  );
}

export default Login;